import { microServicesRoutes } from '@constants';
import { syncApi } from '@lib/apiClients.ts';
import type { ApiResponse, HubspotList, HubspotContact } from '@types';

interface HubspotSyncApiProps {
  getHubspotContactsLists: (organizationId: string, userId: string) => Promise<ApiResponse<HubspotList[]>>;
  getHubspotContacts: (nonce: string, listId: string)=> Promise<ApiResponse<HubspotContact[]>>
}

export function useHubspotSyncApi (): HubspotSyncApiProps {

  const getRootRoute = microServicesRoutes.sync.get.hubspot;

  async function getHubspotContactsLists
  (organizationId: string, userId: string): Promise<ApiResponse<HubspotList[]>> {
    try {
      const url = `${getRootRoute.getContactsLists}/${organizationId}/${userId}`;
      const response: ApiResponse<HubspotList[]> = await syncApi.get(url);

      return { data: response.data, success: true };
    } catch (e: unknown) {
      return { error: { message: 
        'Could not retrieve Hubspot Contacts Lists' }, success: false };
    }
  }
  
  async function getHubspotContacts (nonce: string, listId: string): Promise<ApiResponse<HubspotContact[]>> {
    try {
      const url = `${getRootRoute.getHubspotContacts}/${nonce}/${listId}`;
      const response: ApiResponse<HubspotContact[]> = await syncApi.get(url);
      
      return { data: response.data, success: true };
    } catch (e: unknown) {
      return { error: { message: 
        `Could not retrieve contacts for listId: ${listId} and nonce ${nonce}` },
      success: false };
    }
  }

  return {
    getHubspotContactsLists,
    getHubspotContacts,
  };
}